import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeBugil from "./components/LiftLabelTypeBugil";

const Lift6 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift6"
			 className={getLiftClass(isOpen, activeLiftId === '6', state)}
			 transform="translate(1508.000000, 569.000000)"
		>
			<path
				d="M164,13 L66.9589232,159.717027 L13,227.005074" id="Line-" stroke={colors[0]}
				strokeWidth="3" strokeLinecap="round" strokeDasharray="6" className="animated"/>

			<LiftLabelTypeBugil colors={getLiftStatusColors(state, isOpen)} coords="84.000000, 99.000000" />

			<LabelLift coords="151.000000, 0.000000" text={<tspan x="0.0751953125" y="13">6</tspan>} isOpen={isOpen} state={state}/>

			<g id="Labe-lift" transform="translate(0.000000, 214.005074)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.500000, 226.500000) scale(-1, 1) rotate(-300.000000) translate(-13.500000, -226.500000) "
				points="8 226.5 19 221 16.6285127 226.5 19 232"/>
		</g>
	);
};

Lift6.propTypes = {};

export default Lift6;
